// extracted by mini-css-extract-plugin
export var textInput = "_jz-0";